import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import CreateShortUrl from './containers/CreateShortUrl';
import EditShortUrl from './containers/EditShortUrl';
import ListShortUrls from './containers/ListShortUrls';
import ViewShortUrl from './containers/ViewShortUrl';

const routes = [
    {
        type: 'crud',
        list: ListShortUrls,
        create: CreateShortUrl,
        edit: EditShortUrl,
        view: ViewShortUrl
    }
]

export default ModuleBootstrapper.getRoutes("short-urls", routes)
